/**
 * The bearer credential the admin SPA presents on every `/admin/v1` call
 * (CONTRACT §2.4): the Identity Server session JWT from `/auth/v1`, or in
 * local dev a `fake:<email>` string the service's test verifier accepts. Kept in memory plus sessionStorage (not
 * localStorage) so a page reload survives but nothing lingers across browser
 * restarts or tabs from a shared machine.
 */
const STORAGE_KEY = "spoonity-flags.admin.token";

let token: string | null = null;
const listeners = new Set<(token: string | null) => void>();

export function getToken(): string | null {
  if (token) return token;
  try {
    token = window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    token = null;
  }
  return token;
}

export function setToken(next: string | null): void {
  token = next;
  try {
    if (next) window.sessionStorage.setItem(STORAGE_KEY, next);
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable (private mode, tests) — memory still holds it.
  }
  listeners.forEach((fn) => fn(next));
}

export function onTokenChange(fn: (token: string | null) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** One callback the API client invokes on a 401 so the app can return to sign-in. */
let unauthorizedHandler: (() => void) | null = null;
export function setUnauthorizedHandler(fn: (() => void) | null): void {
  unauthorizedHandler = fn;
}
export function notifyUnauthorized(): void {
  unauthorizedHandler?.();
}
